import { render, staticRenderFns } from "./RevContent.vue?vue&type=template&id=e956bc7a"
import script from "./RevContent.vue?vue&type=script&lang=js"
export * from "./RevContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports